import React from 'react';
import PropTypes from 'prop-types';
import { Dot } from '@jarvis/react-portal-addons';
import { CustomDot } from './styles';

export const ColorColumn = ({ tricolor, 'data-testid': dataTestId }) => {
  if (tricolor) {
    return (
      <Dot
        tricolor size={6.34}
        data-testid={`${dataTestId}`}
      />
    );
  }

  return <CustomDot data-testid={`${dataTestId}`} />;
};

ColorColumn.propTypes = {
  tricolor: PropTypes.bool,
  'data-testid': PropTypes.string,
};

ColorColumn.defaultProps = {
  tricolor: false,
  'data-testid': '',
};

export default ColorColumn;
